
function oxxNormalizeTopSearchQuery(query) {
  const raw = String(query || '').trim();
  if (!raw) return '';

  const cleaned = raw
    .replace(/×/g, 'x')
    .replace(/[，,]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const sizeMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*(?:x|\*)\s*(\d+(?:\.\d+)?)(.*)$/i);
  if (!sizeMatch) return '';

  const id = Number.parseFloat(sizeMatch[1]);
  const cs = Number.parseFloat(sizeMatch[2]);
  if (!Number.isFinite(id) || !Number.isFinite(cs)) return '';

  const tail = String(sizeMatch[3] || '').trim();
  const canonicalSize = `${id.toFixed(2)} x ${cs.toFixed(2)}`;

  return [canonicalSize, tail].filter(Boolean).join(' ').trim();
}

function oxxTopSearchUrl(query) {
  const normalized = oxxNormalizeTopSearchQuery(query);
  if (!normalized) return '';
  return `/search?q=${encodeURIComponent(normalized)}&type=product`;
}


function oxxNormalize(value) {
  return String(value || '').replace(/×/g, 'x').replace(/[，,]/g, ' ').replace(/\s+/g, ' ').trim();
}
function oxxNumber(value) {
  var match = oxxNormalize(value).match(/\d+(?:\.\d+)?/);
  return match ? parseFloat(match[0]) : null;
}
function oxxMaterial(value) {
  var text = oxxNormalize(value).toUpperCase();
  var materials = ['FFKM', 'FKM', 'EPDM', 'SILICONE', 'NBR'];
  for (var i = 0; i < materials.length; i++) {
    if (text.indexOf(materials[i]) !== -1) return materials[i] === 'SILICONE' ? 'Silicone' : materials[i];
  }
  return '';
}
function oxxHardness(value) {
  var match = oxxNormalize(value).toUpperCase().match(/(?:^|\D)(50|60|70|75|80|90)\s*(?:A|SHA|SHORE\s*A)?(?:\D|$)/);
  return match ? match[1] : '';
}
function oxxHandleNumber(value) {
  var number = typeof value === 'number' ? value : oxxNumber(value);
  return number !== null && isFinite(number) ? number.toFixed(2).replace('.', '-') : '';
}
function oxxProductHandle(id, cs, material, hardness) {
  var idHandle = oxxHandleNumber(id);
  var csHandle = oxxHandleNumber(cs);
  var matHandle = oxxMaterial(material).toLowerCase();
  var hardHandle = oxxHardness(hardness);
  if (!idHandle || !csHandle || !matHandle || !hardHandle) return '';
  return 'o-ring-' + idHandle + 'x' + csHandle + '-' + matHandle + '-' + hardHandle.toLowerCase() + 'a';
}
function oxxStandard(value) {
  var text = oxxNormalize(value).toUpperCase();
  var match = text.match(/AS\s*568\s*[-#:]?\s*(\d{1,4})/i);
  if (match) return 'AS568-' + String(match[1]).padStart(3, '0');
  match = text.match(/DIN\s*3771[^,;]*/i);
  if (match) return oxxNormalize(match[0]);
  match = text.match(/ISO\s*3601[^,;]*/i);
  if (match) return oxxNormalize(match[0]);
  return '';
}
function oxxSizeFromQuery(value) {
  var text = oxxNormalize(value);
  var match = text.match(/(\d+(?:\.\d+)?)\s*(?:x|\*)\s*(\d+(?:\.\d+)?)/i);
  if (!match) return { id: null, cs: null };
  var id = parseFloat(match[1]);
  var cs = parseFloat(match[2]);
  if (/\b(in|inch|inches|")\b/i.test(text)) {
    id = id * 25.4;
    cs = cs * 25.4;
  }
  return { id: id, cs: cs };
}
function oxxCollectionFilterUrl(options) {
  var params = new URLSearchParams();
  var standard = oxxStandard(options.standard || options.query || '');
  var id = oxxNumber(options.id);
  var cs = oxxNumber(options.cs);
  var material = oxxMaterial(options.material);
  var hardness = oxxHardness(options.hardness);

  if (standard) params.append('filter.p.m.custom.standard', standard);
  if (id !== null && isFinite(id)) {
    params.append('filter.p.m.custom.inner_diameter_mm.gte', String(id));
    params.append('filter.p.m.custom.inner_diameter_mm.lte', String(id));
  }
  if (cs !== null && isFinite(cs)) {
    params.append('filter.p.m.custom.cross_section_mm.gte', String(cs));
    params.append('filter.p.m.custom.cross_section_mm.lte', String(cs));
  }
  if (material) params.append('filter.p.m.custom.material', material);
  if (hardness) params.append('filter.p.m.custom.shore_hardness', hardness);

  return '/collections/shop-small-packs' + (params.toString() ? '?' + params.toString() : '');
}
function oxxRouteSearchTerm(query) {
  query = oxxNormalize(query);
  if (!query) return '';

  if (window.oxxFinderRoute) {
    var indexedTarget = window.oxxFinderRoute(query);
    if (indexedTarget) return indexedTarget;
  }

  var standard = oxxStandard(query);
  if (standard) return '/search?q=' + encodeURIComponent(standard) + '&type=product';

  var size = oxxSizeFromQuery(query);
  if (size.id !== null && size.cs !== null) {
    return '/search?q=' + encodeURIComponent(query) + '&type=product';
  }

  var material = oxxMaterial(query);
  var hardness = oxxHardness(query);
  if (material || hardness) {
    return oxxCollectionFilterUrl({ material: material, hardness: hardness });
  }

  return '';
}

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.overlay = document.querySelector(".header__overlay");
    this.body = document.querySelector("body");
    this.headerTop = document.querySelector(".header__top");
    this.headerBottom = document.querySelector(".header__bottom");
    this.promoModal = document.querySelector(".search__modal");
    this.headerInput = document.querySelector(".header__search .search__input");
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }


  onOxxPredictiveClick(event) {
    const searchButton = event.target.closest(".predictive-search__search-for-button button");
    if (!searchButton) return;
    const targetUrl = oxxRouteSearchTerm(this.getQuery());
    if (!targetUrl) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = targetUrl;
  }


  onOxxTopSearchClick(event) {
    const searchButton = event.target.closest(".predictive-search__search-for-button button");
    if (!searchButton) return;

    const targetUrl = oxxTopSearchUrl(this.getQuery());
    if (!targetUrl) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = targetUrl;
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      if (this.promoModal && this.classList.contains("search-modal__form")) {
        this.promoModal.classList.remove("search__modal--hidden");
      }
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    const targetUrl = oxxTopSearchUrl(this.getQuery());
    if (targetUrl) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = targetUrl;
      return;
    }

    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (this.classList.contains("search-modal__form")) {
      this.overlay.classList.add("visible");
      this.headerTop.classList.add("header__top--search");
      //this.body.classList.add("overflow-hidden");
      if (this.headerBottom) {
        this.headerBottom.classList.add("header__bottom--visible");
      }
      if (this.promoModal) {
        this.promoModal.classList.remove("search__modal--hidden");
      }
    }

    if (!currentSearchTerm.length) {
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
      if (this.promoModal) {
        this.promoModal.classList.add("search__modal--hidden");
      }
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut(event) {
    if (this.classList.contains("search-modal__form")) {
      this.headerTop.classList.remove("header__top--search");
      this.overlay.classList.remove("visible");
      //this.body.classList.remove("overflow-hidden");
      if (this.headerBottom) {
        this.headerBottom.classList.remove("header__bottom--visible");
      }
    }
    if (event?.relatedTarget) {
      this.input.focus();
      return;
    }
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onBlur() {
    this.headerInput.blur();
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      //case "ArrowUp":
      //	this.switchOption("up");
      //	break;
      //case "ArrowDown":
      //	this.switchOption("down");
      //	break;
      case "Enter":
        this.selectOption();
        break;
      case "Escape":
        this.closeResults(true);
        if (this.promoModal && this.classList.contains("search-modal__form")) {
          this.promoModal.classList.add("search__modal--hidden");
        }
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    if (this.promoModal && this.classList.contains("search-modal__form")) {
      this.promoModal.classList.add("search__modal--hidden");
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&resources[type]=product,article&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.open();
    if (this.promoModal && this.classList.contains("search-modal__form")) {
      this.promoModal.classList.add("search__modal--hidden");
    }
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent
    );
  }

  open() {
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    if (this.promoModal && this.classList.contains("search-modal__form")) {
      this.promoModal.classList.remove("search__modal--hidden");
    }
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    //this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
    if (this.promoModal) {
      this.promoModal.classList.add("search__modal--hidden");
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);
